import Image, { type ImageProps } from 'next/image';

/** Hashed news files use their own cache policy without another optimizer cache. */
export default function NewsImage(props: ImageProps) {
  const derivative =
    typeof props.src === 'string' &&
    /^(?:https?:\/\/[^/]+)?\/(?:news\/images|api\/news\/media)\/[a-f0-9]{64}\.webp$/.test(
      props.src,
    );
  return <Image {...props} unoptimized={derivative || props.unoptimized} />;
}
